<template>
  <div class="flex-col justify-start items-center section_3 pos">
    <div class="flex-col section_7">
      <div class="flex-row group_3 space-x-572">
        <span class="text_4">请输入检测的国际版订单号</span>
        <img
          class="shrink-0 image"
          src="../../assets/55b67414bf5bd9a6f7f30efcc287e799.png"
          @click="closePopup"
        />
      </div>
      <div class="flex-col justify-start self-start text-wrapper_3">
        <span class="font_2 text_5"
          >温馨提示：在店铺中拍下对应数量宝贝，在下方输入淘宝订单号进行检测！</span
        >
      </div>
      <div class="flex-row items-center section_9 space-x-312">
        <div class="flex-row space-x-46">
          <div class="flex-row items-center space-x-6">
            <span class="font_4">总计：</span>
            <span class="font_3">{{ checkData.wordCount }}单词</span>
          </div>
          <div class="flex-row items-center space-x-6">
            <span class="font_4">件数：</span>
            <span class="font_3">{{ checkData.number }}件</span>
          </div>
        </div>
        <div
          class="flex-col justify-start items-center text-wrapper_4"
          @click="toTaobao"
        >
          <span class="font_2">淘宝购买</span>
        </div>
      </div>
      <div class="flex-col justify-start self-start text-wrapper_3_1">
        <span class="font_2 text_5" style="color: red;"
          >提示："件数"按500单词/件计数，其他类型请忽略！</span
        >
      </div>
      <div class="flex-col group_3 view space-y-24">
        <div class="flex-row items-center">
          <span class="font_2 text_6">请输入订单编号：</span>
          <Input
            v-model="orderno"
            placeholder="请输入订单编号(多个订单号用 # 连接)"
            class="flex-col justify-start items-start text-wrapper_5"
          />
        </div>
        <div class="flex-col items-start" v-if="checkOrder.length > 0">
          <span class="font_6" v-for="(num, index) in checkOrder" :key="index"
            >
            <span v-if="num.shop === 'Biyeguo' | num.shop === null | !num.shop">
              <span v-if="num.type === 'once'">
              第{{ index + 1}}个订单编号 订单件数：{{
                num.total || 0
                }}
                、已用件数：{{ num.use || 0 }} 、可用件数：{{
                num.surplus || 0
                }}
                、类型：次卡
              </span>
              <span v-else-if="num.type === 'US once'">
            第{{ index + 1}}个订单编号 订单件数：{{
              num.total || 0
              }}
              、已用件数：{{ num.use || 0 }} 、可用件数：{{
              num.surplus || 0
              }}
              类型：国际版次卡
            </span>
              <span v-else-if="num.type === 'simu only'">
              第{{ index + 1}}个订单编号 订单件数：{{
                num.total || 0
                }}
                、已用件数：{{ num.use || 0 }} 、可用件数：{{
                num.surplus || 0
                }}
                、类型：仅查重次卡
              </span>
              <span v-else-if="num.type === 'AI only'">
              第{{ index + 1}}个订单编号 订单件数：{{
                num.total || 0
                }}
                、已用件数：{{ num.use || 0 }} 、可用件数：{{
                num.surplus || 0
                }}
                、类型：仅查AI次卡
              </span>
              <span v-else-if="num.type === 'one time'">
              第{{ index + 1}}个订单编号 订单件数：{{
                num.total || 0
                }}
                、已用件数：{{ num.use || 0 }} 、可用件数：{{
                num.surplus || 0
                }}
                、类型：单次检测卡
              </span>
              <span v-else-if="num.type === 'two time'">
              第{{ index + 1}}个订单编号 订单件数：{{
                num.total || 0
                }}
                、已用件数：{{ num.use || 0 }} 、可用件数：{{
                num.surplus || 0
              }}
              、类型：两次检测卡
              </span>
              <span v-else-if="num.type === 'three time'">
              第{{ index + 1}}个订单编号 订单件数：{{
                num.total || 0
                }}
                、已用件数：{{ num.use || 0 }} 、可用件数：{{
                num.surplus || 0
              }}
              、类型：三次检测卡
              </span>
              <span v-else-if="num.type === 'five time'">
              第{{ index + 1}}个订单编号 订单件数：{{
                num.total || 0
                }}
                、已用件数：{{ num.use || 0 }} 、可用件数：{{
                num.surplus || 0
              }}
              、类型：五次检测卡
              </span>
              <span v-else-if="num.type === 'simu only one time'">
              第{{ index + 1}}个订单编号 订单件数：{{
                num.total || 0
                }}
                、已用件数：{{ num.use || 0 }} 、可用件数：{{
                num.surplus || 0
                }}
                、类型：仅查重单次卡
              </span>
              <span v-else-if="num.type === 'simu only two time'">
              第{{ index + 1}}个订单编号 订单件数：{{
                num.total || 0
                }}
                、已用件数：{{ num.use || 0 }} 、可用件数：{{
                num.surplus || 0
              }}
              、类型：仅查重两次卡
              </span>
              <span v-else-if="num.type === 'simu only three time'">
              第{{ index + 1}}个订单编号 订单件数：{{
                num.total || 0
                }}
                、已用件数：{{ num.use || 0 }} 、可用件数：{{
                num.surplus || 0
              }}
              、类型：仅查重三次卡
              </span>
              <span v-else-if="num.type === 'AI only one time'">
              第{{ index + 1}}个订单编号 订单件数：{{
                num.total || 0
                }}
                、已用件数：{{ num.use || 0 }} 、可用件数：{{
                num.surplus || 0
                }}
                、类型：仅查AI单次卡
              </span>
              <span v-else-if="num.type === 'AI only two time'">
              第{{ index + 1}}个订单编号 订单件数：{{
                num.total || 0
                }}
                、已用件数：{{ num.use || 0 }} 、可用件数：{{
                num.surplus || 0
              }}
              、类型：仅查AI两次卡
              </span>
              <span v-else-if="num.type === 'AI only three time'">
              第{{ index + 1}}个订单编号 订单件数：{{
                num.total || 0
                }}
                、已用件数：{{ num.use || 0 }} 、可用件数：{{
                num.surplus || 0
              }}
              、类型：仅查AI三次卡
              </span>
              <span v-else-if="num.type === 'US day'">
              第{{ index + 1 }}个订单编号 订单件数：{{
                num.total || 0
                }}
                、类型：国际版天卡 过期时间：{{
                num.expire_at ||0
                }}
              </span>
              <span v-else-if="num.type === 'US three day'">
              第{{ index + 1 }}个订单编号 订单件数：{{
                num.total || 0
                }}
                、类型：国际版三天卡 过期时间：{{
                num.expire_at ||0
                }}
              </span>
              <span v-else-if="num.type === 'US week'">
              第{{ index + 1 }}个订单编号 订单件数：{{
                num.total || 0
                }}
                、类型：国际版周卡 过期时间：{{
                num.expire_at ||0
                }}
              </span>
              <span v-else-if="num.type === 'US halfmonth'">
              第{{ index + 1 }}个订单编号 订单件数：{{
                num.total || 0
                }}
                、类型：国际版半月卡 过期时间：{{
                num.expire_at ||0
                }}
              </span>
              <span v-else-if="num.type === 'US month'">
              第{{ index + 1 }}个订单编号 订单件数：{{
                num.total || 0
                }}
                、类型：国际版月卡 过期时间：{{
                num.expire_at ||0
                }}
              </span>
              <span v-else-if="num.type === 'US two month'">
              第{{ index + 1 }}个订单编号 订单件数：{{
                num.total || 0
                }}
                、类型：国际版两月卡 过期时间：{{
                num.expire_at ||0
                }}
              </span>
              <span v-else-if="num.type === 'US quarter'">
              第{{ index + 1 }}个订单编号 订单件数：{{
                num.total || 0
                }}
                、类型：国际版季卡 过期时间：{{
                num.expire_at ||0
                }}
              </span>
              <span v-else-if="num.type === 'US halfyear'">
              第{{ index + 1 }}个订单编号 订单件数：{{
                num.total || 0
                }}
                、类型：国际版半年卡 过期时间：{{
                num.expire_at ||0
                }}
              </span>
              <span v-else-if="num.type === 'US year'">
              第{{ index + 1 }}个订单编号 订单件数：{{
                num.total || 0
                }}
                、类型：国际版年卡 过期时间：{{
                num.expire_at ||0
                }}
              </span>
              <span v-else>
                第{{ index + 1 }}个订单编号：无效订单
              </span>
            </span>
            <span v-else>
              第{{ index + 1 }}个订单编号：无效订单号
            </span>
          </span>
        </div>
        <div class="flex-col space-y-32">
          <div class="flex-col section_10">
            <div class="flex-col justify-start items-start text-wrapper_7">
              <span class="font_7 text_9">说明：</span>
            </div>
            <div class="group_4">
              <span class="font_6">
                正常下只需填写一个订单编号，如果订单编号金额不足，可添加第二个，系统会合并金额；
              </span>
              <span class="font_6 text_10">
                输入订单编号后，点击按钮【可用件数查询】可查询该单号的可用件数等信息
              </span>
            </div>
          </div>
          <div class="flex-row space-x-8">
            <div
              class="flex-col justify-start items-center text-wrapper_8"
              @click="closePopup"
            >
              <span class="font_7">关闭</span>
            </div>
            <div
              class="flex-col justify-start items-center text-wrapper_9"
              @click="checkNum"
            >
              <span class="font_2 text_11">可用件数查询</span>
            </div>
            <div class="flex-row items-center space-x-4">
              <Button
                type="primary"
                :loading="check_loading"
                @click.once="handleSubmit"
                class="section_11"
              >
                <span>立即检测</span>
              </Button>
              <!--<img class="shrink-0 image" src="../../assets/1f0a3d67f2a4f505f40c231befb0ac76.png" />
              <span class="font_2">立即检测</span>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal v-model="sub_success" width="360">
      <template #header>
        <p style="color: #19be6b; text-align: center">
          <Icon type="ios-checkmark-circle" />
          <span>提交成功</span>
        </p>
      </template>
      <div style="text-align: center">
        <p>论文检测已提交成功，请耐心等待检测结果！</p>
      </div>
      <template #footer>
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="closeModel"
          >查看报告</Button
        >
      </template>
    </Modal>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    checkData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    paperData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      taobaolink:"",
      orderno: "",
      checkOrder: [],
      check_loading: false,
      modal_loading: false,
      sub_success: false,
    };
  },
  mounted() {
    this.getConfig();
  },
  methods: {
    getConfig() {
      var params = {
        shop: "Biyeguo",
      };
      this.http
        .post(this.api.getConfig, params)
        .then((res) => {
          console.log(res.data);
          // 循环遍历，当explain是“商家店铺”的时候，就是淘宝链接
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].shop == "Biyeguo") {
              this.taobaolink = res.data[i].purchase_url;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    closeModel() {
      /* this.modal_loading = true;
            setTimeout(() => {
                this.modal_loading = false;
                this.sub_success = false;
            }, 2000);*/
      //this.$emit('closePopup', 1);
      //orderto = this.orderno
      //$orderArray = explode("#", $orderto);

      this.$router.push({
        name: "chakanbaogao",
    
        params: { orderno: this.orderno},
      });
    },
    toTaobao() {
      window.open(this.taobaolink, "_blank");
    },
    closePopup() {
      this.$Modal.confirm({
        title: "确认关闭？",
        okText: "确认",
        cancelText: "取消",
        onOk: () => {
          this.$emit("closePopup", 1);
        },
      });
    },
    checkNum() {
      if (!this.orderno) {
        this.$Message["error"]({
          background: true,
          content: "请输入订单编号查询",
        });
        return false;
      }
      var params = {
        order_no: this.orderno,
      };
      this.http
        .post(this.api.searchNumber, params)
        .then((res) => {
          let { code, data } = res.data;
          if (code == 200) {
            this.checkOrder = data;
            console.log("提交查询" + data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleSubmit() {
      console.log(this.paperData);
      if (!this.orderno) {
        this.$Message["error"]({
          background: true,
          content: "请输入订单编号查询",
        });
        return false;
      }
      let formData = new FormData();
      formData.append("type", this.paperData.type);
      formData.append("title", this.paperData.title);
      formData.append("order_no", this.orderno);
      formData.append("content", this.paperData.content);
      formData.append("file", this.paperData.file);
      formData.append("firstName", this.paperData.firstName);
      formData.append("lastName", this.paperData.lastName);
      formData.append("checktype", "US");
      formData.append("shop","Biyeguo")
      formData.append("exclude", this.paperData.exclude);
      this.check_loading = true;
      this.http
        .post(this.api.submitArticle, formData)
        .then((res) => {
          this.check_loading = false;
          let { code, data } = res.data;
          if (code == 200) {
            this.sub_success = true;
            //this.instance(success);
          } else {
            this.check_loading = false;
            this.$Message["error"]({
              background: true,
              content: res.data.msg,
            });
          }
        })
        .catch((error) => {
          this.check_loading = false;
          this.$Message["error"]({
            background: true,
            //content: res.data.msg,
            content: "检测失败",
          });
          console.log(error);
        });
    },
    instance(type) {
      const title = "提交成功";
      const content = "<p>提交成功</p><p>请等待…</p>";
      switch (type) {
        case "info":
          this.$Modal.info({
            title: title,
            content: content,
          });
          break;
        case "success":
          this.$Modal.success({
            title: title,
            content: content,
          });
          break;
        case "warning":
          this.$Modal.warning({
            title: title,
            content: content,
          });
          break;
        case "error":
          this.$Modal.error({
            title: title,
            content: content,
          });
          break;
      }
    },
  },
};
</script>

<style scoped lang="less">
.section_3 {
  padding: 10.75rem 0;
  //background-color: hsla(0, 0%, 0%, 0.5);
  //backdrop-filter: blur(0.13rem);
  .section_7 {
    padding: 0 1.5rem;
    background-color: hsl(0, 0%, 100%);
    border-radius: 0.5rem;
    box-shadow: 0.13rem 0.13rem 0.5rem hsla(217, 11.5%, 35.9%, 0.08),
      0.063rem 0.063rem 0.13rem hsla(217, 11.5%, 35.9%, 0.04);
    width: 50rem;
    .group_3 {
      padding: 1.5rem 0;
      .text_4 {
        color: hsl(208, 11.9%, 21.4%);
        font-size: 1.13rem;
        //font-family: PingFang SC;
        font-weight: 600;
        line-height: 1.06rem;
      }
      .text_6 {
        color: hsl(0, 0%, 0%);
      }
      .text-wrapper_5 {
        border-radius: 0.25rem;
        width: 22.88rem;
        height: 1.88rem;
        .text_7 {
          margin-left: 0.5rem;
        }
      }
      .text-wrapper_6 {
        margin-left: 0.19rem;
        padding: 0.5rem 0;
        background-color: hsl(220, 23.1%, 97.5%);
        border-radius: 0.25rem;
        height: 1.88rem;
        border: solid 0.063rem hsl(216, 6.2%, 84.1%);
        .text_8 {
          margin-left: 0.5rem;
        }
      }
      .font_5 {
        font-size: 0.88rem;
        //font-family: PingFang SC;
        line-height: 0.81rem;
        color: hsl(225, 3%, 74.1%);
      }
      .font_6 {
        font-size: 0.88rem;
        //font-family: PingFang SC;
        line-height: 1.25rem;
        color: hsl(208, 11.9%, 21.4%);
      }
      .space-y-32 {
        & > *:not(:first-child) {
          margin-top: 2rem;
        }
        .section_10 {
          padding-bottom: 1rem;
          background-color: hsl(0, 0%, 100%);
          border-radius: 0.25rem;
          box-shadow: 0.13rem 0.13rem 0.5rem hsla(217, 11.5%, 35.9%, 0.08),
            0.063rem 0.063rem 0.13rem hsla(217, 11.5%, 35.9%, 0.04);
          border: solid 0.063rem hsl(216, 6.2%, 84.1%);
          .text-wrapper_7 {
            padding: 0.75rem 0;
            background-color: hsl(210, 14.3%, 97.3%);
            border-radius: 0.25rem 0.25rem 0px 0px;
            width: 47rem;
            height: 2.5rem;
            border: solid 0.063rem hsl(216, 6.2%, 84.1%);
            .text_9 {
              margin-left: 1.25rem;
            }
          }
          .group_4 {
            margin: 1rem 1.5rem 0 1rem;
            line-height: 1.25rem;
            .text_10 {
              color: hsl(134, 100%, 35.3%);
            }
          }
        }
        .space-x-8 {
          & > *:not(:first-child) {
            margin-left: 0.5rem;
          }
          .text-wrapper_8 {
            cursor: pointer;
            margin-left: 24.19rem;
            padding: 0.5rem 0;
            border-radius: 0.25rem;
            width: 4.81rem;
            height: 2rem;
            border: solid 0.063rem hsl(210, 4.9%, 83.9%);
          }
          .text-wrapper_9 {
            cursor: pointer;
            padding: 0.5rem 0;
            border-radius: 0.25rem;
            width: 8.44rem;
            height: 2rem;
            border: solid 0.063rem hsl(207, 82%, 32%);
            .text_11 {
              color: hsl(207, 82%, 32%);
            }
          }
          .section_11 {
            cursor: pointer;
            /*padding: 0.5rem 1.5rem;*/
            background-color: hsl(207, 82%, 32%);
            border-color: hsl(207, 82%, 32%);
            border-radius: 0.25rem;
            width: 8.56rem;
            height: 2rem;
          }
          .space-x-4 {
            & > *:not(:first-child) {
              margin-left: 0.25rem;
            }
          }
        }
        .font_7 {
          font-size: 0.88rem;
          //font-family: PingFang SC;
          line-height: 0.81rem;
          color: hsl(208, 11.9%, 21.4%);
        }
      }
    }
    .space-x-572 {
      & > *:not(:first-child) {
        margin-left: 35.75rem;
      }
    }
    .text-wrapper_3 {
      padding: 0.75rem 0 0.5rem;
      background-color: hsla(40, 100%, 59%, 0.1);
      border-radius: 0.13rem;
      height: 2.25rem;
      border: solid 0.063rem hsl(40, 95.8%, 52.9%);
      .text_5 {
        margin-left: 0.5rem;
        margin-right: 0.25rem;
        color: hsl(40, 95.8%, 52.9%);
        line-height: 0.88rem;
      }
    }
    .text-wrapper_3_1 {
      padding: 0.75rem 0 0.5rem;
      background-color: hsla(92, 15%, 78%, 0.1);
      border-radius: 0.13rem;
      height: 2.25rem;
      border: solid 0.063rem hsl(207, 82%, 32%);
      .text_5 {
        margin-left: 0.5rem;
        margin-right: 0.25rem;
        color: hsl(207, 82%, 32%);
        line-height: 0.88rem;
      }
    }
    .section_9 {
      margin-top: 1.5rem;
      padding: 1rem;
      background-color: hsl(220, 23.1%, 97.5%);
      .space-x-46 {
        flex: 1;
        & > *:not(:first-child) {
          margin-left: 2.88rem;
        }
        .space-x-6 {
          & > *:not(:first-child) {
            margin-left: 0.38rem;
          }
          .font_4 {
            font-size: 1rem;
            //font-family: PingFang SC;
            line-height: 0.94rem;
            color: hsl(208, 11.9%, 21.4%);
          }
          .font_3 {
            font-size: 1.5rem;
            //font-family: PingFang SC;
            line-height: 1.41rem;
            color: hsl(208, 11.9%, 21.4%);
          }
        }
      }
      .text-wrapper_4 {
        cursor: pointer;
        padding: 0.63rem 0;
        background-color: hsl(207, 82%, 32%);
        border-radius: 0.25rem;
        width: 6.63rem;
        height: 2rem;
      }
    }
    .view {
      margin-top: 0.5rem;
    }
    .space-y-24 {
      & > *:not(:first-child) {
        margin-top: 1.5rem;
      }
    }
  }
}
.pos {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.image {
  width: 1rem;
  height: 1rem;
}
.font_2 {
  font-size: 0.88rem;
  //font-family: PingFang SC;
  line-height: 0.81rem;
  color: hsl(0, 0%, 100%);
}
@media (max-width: 820px) {
  .section_3 .section_7 {
    width: 100%;
    .group_3 .text_4 {
      flex: 1;
    }
    .space-x-572 {
      & > *:not(:first-child) {
        margin-left: 0;
      }
    }
    .group_3 .space-y-32 {
      .section_10 .text-wrapper_7 {
        width: 100%;
      }
      .space-x-8 .text-wrapper_8 {
        margin-left: 0;
      }
    }
  }
}
@media (max-width: 660px) {
  .section_3 .section_7 {
    .text-wrapper_3 {
      height: auto;
      .text_5 {
        line-height: inherit;
      }
    }
    .group_3 {
      .text-wrapper_5 {
        width: auto;
      }
      .text-wrapper_6 {
        display: none;
      }
    }
  }
}
@media (max-width: 450px) {
  .section_3 .section_7 {
    .section_9 {
      display: block;
    }
    .section_9 .text-wrapper_4 {
      margin-top: 1rem;
    }
  }
}
</style>
